import  LoginService  from './../../../services/auth-service';
import { Navigate  } from 'react-router-dom';
import Login from  './../../features/login/login.component';
import { useSelector } from 'react-redux';

const LoginGuard = () => {
  const userData = useSelector(state => state.authReducer);
  const useUserPermissionData = (permcode) => {
      
    if (!userData || !userData.user || !userData.user.data || !userData.user.data.role || !userData.user.data.role.permissions)
        return false;

    const permissionArr = userData.user.data.role.permissions;
    return permissionArr.some(permission => permission.permission_code === permcode);
}
    if (LoginService.getAccessToken()) {
      if(useUserPermissionData('dashboard_agent')) {
        return <Navigate to="/dashboard" replace />;
      }
      else if (useUserPermissionData('dashboard_owner')) {
        return <Navigate to="/admin-dashboard" replace />;
      }
      else if(useUserPermissionData('dashboard_merchant')) {
        return <Navigate to="/merchant-dashboard" replace />;
      }
       else if(useUserPermissionData('user_management')) {
        return <Navigate to="/users" replace />;
      }
      else if (useUserPermissionData('transaction_management')) {
        return <Navigate to="/transactions" replace />;
      }
      else if (useUserPermissionData('commission_management')) {
        return <Navigate to="/commissions" replace />;
      }
      else if (useUserPermissionData('agent_management')) {
        return <Navigate to="/agents" replace />;
        
      }
      else if (useUserPermissionData('merchant_management')) {
        return <Navigate to="/merchants" replace />;
       
      }
      else if (useUserPermissionData('payment_method_system')) {
        return <Navigate to="/admin-payments" replace />;
       
      }
      else if (useUserPermissionData('commission_group_management')) {
        return <Navigate to="/commission-groups" replace />;
       
      }
      else if (useUserPermissionData('limit_group_management')) {
        return <Navigate to="/limits" replace />;
       
      }
      else if (useUserPermissionData('payment_method_user')) {
        return <Navigate to="/payment-methods" replace />;
       
      }
      else if (useUserPermissionData('crypto_merchant')) {
        return <Navigate to="/crypto-list" replace />;
       
      }
      else {
        return <Navigate to="/users" replace />;
      }
      // Redirect authenticated users to the home page or dashboard
     
    } else {
      // Render the Login component for unauthenticated users
      return <Login />;
    }

    
  };

  export default LoginGuard